// fw Pill — a small uppercase state chip.
//
// Tone is colour AND is exposed as data-tone, so job state is never colour
// alone (spec §6). 'now' additionally draws a filled dot via CSS ::before.

import React from 'react';
import './Pill.css';

export const PILL_TONES = ['now', 'ok', 'sched', 'stop', 'warn', 'neutral'];

export function Pill({ tone = 'neutral', className = '', children, ...rest }) {
  const t = PILL_TONES.includes(tone) ? tone : 'neutral';
  return (
    <span
      className={['fw-pill', `fw-pill--${t}`, className].filter(Boolean).join(' ')}
      data-tone={t}
      {...rest}
    >
      {children}
    </span>
  );
}

export default Pill;
